import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { Modal, Select, Button as ButtonAnt, message } from 'antd'
import { CombileLabelsShipByTiktokOrder } from '../../../services/api/apiNextBarcode'

const CombineLabels = (props) => {
    const [isOpen, setIsOpen] = useState(false)
    const [listItems, setListItems] = useState([])
    const [emails, setEmails] = useState([])
    const [loading, setLoading] = useState(false)

    const _handleToggleModal = () => {
        setIsOpen(preState => !preState)
        setListItems([])
        setEmails([])
    }

    const handleChangeSelect = (field, value) => {
        if (field === 'emails') setEmails(value)
        if (field === 'listItems') {
            const newValue = value.map(v => {
                const nv = v.trim().replace("#", '')
                if(nv.includes("_")){
                    const [v1, v2] = nv.split("_")
                    return v1
                }

                return nv
            }).filter(Boolean)
            setListItems([...new Set(newValue)])
        }
    }

    const handleCombileLabels = async () => {
        setLoading(true)
        const payload = {
            "receiver_email": emails,
            "orders": listItems.map(i => !!i && +i).filter(Boolean),
            "force": true,
            "orders_per_file": 100,
            "fit_labels": false
        }
        try {
            const res = await CombileLabelsShipByTiktokOrder(payload)
            const { success, data, message: mess } = { ...res }
            if (!success) { throw new Error(mess) }
            message.success(`Gộp labels đơn shipbytiktok thành công.`)
            _handleToggleModal()
            props.reload()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <Button
                className="btn btn-light btn-labeled btn-labeled-left ml-1"
                onClick={_handleToggleModal}
            >
                <b><i style={{ fontSize: '16px' }} className="fa fa-tag" /></b>
                Combine Labels
            </Button>

            <Modal
                title="Gộp labels đơn shipbytiktok"
                visible={isOpen}
                onCancel={_handleToggleModal}
                footer={[
                    <ButtonAnt
                        key="close"
                        onClick={_handleToggleModal}
                        disabled={loading}
                    >
                        Đóng
                    </ButtonAnt>,
                    <ButtonAnt
                        key="submit"
                        type="primary"
                        onClick={handleCombileLabels}
                        disabled={loading || !emails.length}
                        loading={loading}
                    >
                        Gộp labels
                    </ButtonAnt>
                ]}
                className="BulkChangeStatus"
                width={600}
            >
                <div className="listItems mb-3">
                    <h6>Danh sách mã đơn:</h6>
                    <Select
                        className="barcode"
                        mode="tags"
                        value={listItems}
                        style={{ width: '100%' }}
                        placeholder="Danh sách mã đơn"
                        allowClear
                        tokenSeparators={[',', ' ']}
                        onChange={(value) => handleChangeSelect('listItems', value)}
                        virtual={false}
                        open={false}
                    />
                </div>

                <div className="emails mb-3">
                    <h6>Email:</h6>
                    <Select
                        className='email'
                        mode={'tags'}
                        value={emails || []}
                        style={{ width: '100%' }}
                        placeholder='Nhập email...'
                        allowClear
                        tokenSeparators={[',', ' ']}
                        onChange={(value) => handleChangeSelect('emails', value)}
                        virtual={false}
                        open={false}
                    />
                </div>

                {/* {itemsNotShipByTiktok.length > 0 && (
                    <div className="haveNotShipByTiktok">
                        {itemsNotShipByTiktok.map(i => (
                            <div key={i.barcodeNumber} className="text-danger">
                                {`Có đơn ${i.barcodeNumber} không phải shipbytiktok có muốn tiếp tục xử lý không?`}
                            </div>
                        ))}
                    </div>
                )} */}

                <h5 className="mb-0 mt-3 font-weight-bold">
                    Liên hệ với đội dev nếu sau 30 phút không nhận được email kết quả!
                </h5>
            </Modal>

        </React.Fragment>
    )
}

export default CombineLabels